










































import { Component, Prop, Vue } from "vue-property-decorator";
import Tag from "@/components/Card/Tag.vue";
import Schedule from "@/components/Card/Schedule.vue";
import Name from "@/components/Card/Name.vue";
import Description from "@/components/Card/Description.vue";
import TrainerName from "@/components/Card/TrainerName.vue";
import Btns from "@/components/Card/Btns.vue";
import { DataItem } from "@/data.model";
@Component({
  components: { TrainerName, Description, Name, Schedule, Tag, Btns }
})
export default class Card extends Vue {
  @Prop() readonly item!: DataItem;
  @Prop() readonly type!: "TABLE" | "LIST";

  get isList() {
    return this.type === "LIST";
  }

  get isTable() {
    return this.type === "TABLE";
  }
}
